import { Badge, Header } from "@funcional/react-ui";
import { useUsers } from "@sso/users/hooks";
import { IUser } from "@sso/users/contracts";
import { useMemo } from "react";
import { Column } from "react-table";
import { useHistory } from "react-router-dom";
import { IntlEnum } from "@funcional/react-intl-ui";
import { DefaultColumnFilter, GridView } from "@funcional/react-table-ui";

export default function ListUsersInfoPage() {
  const history = useHistory();

  const editRecord = (row: any) =>
    history.push(`/sso/users/${row.original.uuid}/edit`);

  const showRecord = (row: any) =>
    history.push(`/sso/users/${row.original.uuid}`);

  const columns: Column<IUser>[] = useMemo(
    () => [
      {
        Header: "Nome",
        accessor: "name",
      },
      {
        Header: "Email",
        accessor: "email",
        Filter: DefaultColumnFilter,
      },
      {
        Header: "CPF",
        accessor: "identity",
        Filter: DefaultColumnFilter,
      },
      {
        Header: "Código",
        accessor: "uuid",
        Filter: DefaultColumnFilter,
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => (
          <Badge
            color={
              value === "ACTIVE"
                ? "success"
                : value === "UNCONFIRMED"
                ? "warning"
                : "danger"
            }
          >
            <IntlEnum name="user_status" value={value} />
          </Badge>
        ),
      },
    ],
    []
  );

  return (
    <>
      <Header title="Usuários" />

      <GridView<IUser>
        accessControlResourceName="users"
        paginationType="page"
        columns={columns}
        hook={useUsers}
        editRecord={editRecord}
        showRecord={showRecord}
        defaultFilters={[]}
      />
    </>
  );
}
